import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { NAV } from "@/constants/testIds";

const links = [
  { to: "/", label: "Home", tid: NAV.home, end: true },
  { to: "/about", label: "About", tid: NAV.about },
  { to: "/personal-training", label: "Personal Training", tid: "nav-personal-training" },
  { to: "/macros", label: "Macros", tid: "nav-macros" },
  { to: "/support", label: "Support", tid: NAV.support },
  { to: "/contact", label: "Contact", tid: "nav-contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "bg-[#0A0A0A]/95 backdrop-blur-md border-[rgba(255,255,255,0.08)]"
          : "bg-[#0A0A0A] border-[rgba(255,255,255,0.06)]"
      }`}
    >
      <div className="dta-container flex items-center justify-between h-16 md:h-20 text-white">
        <div className="flex items-center gap-10">
          <Link to="/" data-testid={NAV.logo} className="flex items-center">
            <LogoMark light />
          </Link>
          <nav className="hidden md:flex items-center gap-5 lg:gap-7">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={l.tid}
                className={({ isActive }) =>
                  `dta-overline text-[0.7rem] transition-colors ${
                    isActive ? "text-white" : "text-white/60 hover:text-white"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-4 md:gap-6">
          <a
            href="https://instagram.com/downtestadjust"
            target="_blank"
            rel="noreferrer"
            className="hidden md:inline-flex dta-overline text-[0.65rem] text-white/60 hover:text-white transition-colors"
          >
            @downtestadjust
          </a>
          <button
            className="md:hidden text-white"
            aria-label="Menu"
            data-testid={NAV.mobileToggle}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A0A0A] border-t border-[rgba(255,255,255,0.06)] text-white">
          <nav className="dta-container py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`${l.tid}-mobile`}
                className="dta-overline text-sm text-white/80 hover:text-white"
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
